import { readApprovedAddressWithdrawal } from './address-withdrawal';
import { assertTransferRecipient, isCommandResult } from './coin-arguments';
import { SendAssertionError, type TransferValidationStrategy } from './transaction-validation';

export const assertAddressBalanceTransfer: TransferValidationStrategy = (context) => {
  const { commands, inputs, expected } = context;
  const addressAmount = readApprovedAddressWithdrawal(context);
  const transfer = commands[commands.length - 1];
  if (transfer?.$kind !== 'TransferObjects' || transfer.TransferObjects.objects.length !== 1) {
    throw new SendAssertionError('it must transfer exactly one approved coin');
  }
  assertTransferRecipient(transfer.TransferObjects.address, inputs, expected.recipient);
  const [transferred] = transfer.TransferObjects.objects;

  if (
    addressAmount !== expected.amount ||
    commands.length !== 2 ||
    !isCommandResult(transferred, 0)
  ) {
    throw new SendAssertionError('it combines address funds outside the approved transfer');
  }
};
